import gsap from 'gsap'
import Flip from 'gsap/dist/Flip'
import GSDevTools from 'gsap/dist/GSDevTools'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import SplitText from 'gsap/dist/SplitText'

if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger, SplitText, Flip, GSDevTools)

}
